import { Link, type LinkProps } from "react-router-dom";
import { trackCTA } from "@/lib/analytics";
import { forwardRef } from "react";

interface TrackedLinkProps extends LinkProps {
  /** Button/link label for GA4 event_label */
  trackLabel: string;
  /** Location on the page for GA4 event_location */
  trackLocation: string;
}

const TrackedLink = forwardRef<HTMLAnchorElement, TrackedLinkProps>(
  ({ trackLabel, trackLocation, onClick, ...props }, ref) => {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      trackCTA(trackLabel, trackLocation);
      onClick?.(e);
    };

    return <Link ref={ref} onClick={handleClick} {...props} />;
  }
);

TrackedLink.displayName = "TrackedLink";

export default TrackedLink;
